<p-table class="pricing-table" [value]="selectedPlatforms()">
  <ng-template #header>
    <tr>
      <th style="width: 90%"></th>
      <th style="width: 10%"></th>
    </tr>
  </ng-template>
  <ng-template #body let-platform>
    <tr class="platform">
      <td>{{ platform.title }}</td>
      <td class="text-right">{{ platform.price | formatPrice }}</td>
    </tr>
  </ng-template>
  <ng-template #footer>
    <tr>
      <td>
        <b>{{
          'company-tool.views.jobs.posting.sections.publication.job-markets.total'
            | transloco
        }}</b>
      </td>
      <td class="text-right">{{ price() | formatPrice }}</td>
    </tr>
    @if (price()) {
      <tr>
        <td colspan="2" class="vat-note">
          {{ 'company-tool.snippets.invoice-booking.vat-note' | transloco }}
        </td>
      </tr>
    }
  </ng-template>
</p-table>
